import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { selectorTaxRateLabel } from "../../../shared/selectors/selectorTaxRateLabel";
import { useTaxWithholdingsStatus } from "../hooks/useTaxWithholdingsStatus";

type Props = WSModalCustomProps<boolean>;

export const ModalTurnOn: React.FC<Props> = modalProps => {
  const { rate } = useTaxWithholdingsStatus();

  return (
    <WSModal
      title="Tax withholdings"
      size="S"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Save when I get paid",
            onClick: () => {
              modalProps.onClose(true);
            }
          },
          {
            label: "Cancel",
            kind: "Tertiary",
            onClick: () => {
              modalProps.onClose(false);
            }
          }
        ]
      }}
      {...modalProps}
      onClose={() => {
        modalProps.onClose(false);
      }}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Set aside {selectorTaxRateLabel(rate ?? 0)} of each invoice paid
          through Wingspan.
        </WSText.ParagraphSm>
      </WSList>
    </WSModal>
  );
};

export const useModalTurnOn = () => useWSModalCustom(ModalTurnOn);
